<template>
    <div class="faq-page">
        <header class="faq-hero">
            <div class="faq-hero-content">
                <div class="hero-inner">
                    <h1 class="faq-title">Foire Aux Questions</h1>
                    <p class="faq-subtitle">
                        Retrouvez ici les reponses aux questions les plus frequemment posees.
                    </p>
                </div>
            </div>
        </header>

        <main class="faq-container">
            <section class="faq-list">
                <article class="faq-item" v-for="(item, index) in faqItems" :key="index" :class="{ active: openItem === index }">
                    <button class="faq-header" @click="toggleFaq(index)">
                        <h2 class="faq-question">{{ item.question }}</h2>
                        <span class="faq-icon">
                            <i class="fa fa-chevron-down"></i>
                        </span>
                    </button>
                    <div class="faq-answer">
                        <p>{{ item.answer }}</p>
                    </div>
                </article>
            </section>
        </main>

        <footer class="footer-section">
            <div class="footer-container">
                <div class="footer-left">
                    <div class="footer-logo-section">
                        <img src="https://i.imgur.com/z198fac.png" alt="MyEcoCar Logo" class="footer-logo" />
                        <span class="footer-brand-name">MyEcoCar</span>
                    </div>
                    <div class="footer-social-links">
                        <a href="#" class="social-link" title="Facebook">
                            <i class="fa fa-facebook-f"></i>
                        </a>
                        <a href="#" class="social-link" title="Twitter">
                            <i class="fa fa-twitter"></i>
                        </a>
                        <a href="#" class="social-link" title="Instagram">
                            <i class="fa fa-instagram"></i>
                        </a>
                        <a href="#" class="social-link" title="LinkedIn">
                            <i class="fa fa-linkedin"></i>
                        </a>
                    </div>
                </div>

                <div class="footer-center">
                    <div class="footer-column">
                        <h4 class="footer-column-title">Infos</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'cgu' }">CGU</router-link></li>
                            <li><router-link :to="{ name: 'faq' }">FAQ</router-link></li>
                            <li><router-link :to="{ name: 'contact' }">Contact</router-link></li>
                        </ul>
                    </div>

                    <div class="footer-column">
                        <h4 class="footer-column-title">Decouvrir</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'about' }">Qui sommes-nous ?</router-link></li>
                            <li><router-link :to="{ name: 'conduct-charter' }">Charte de bonne conduite</router-link></li>
                            <li><router-link :to="{ name: 'map' }">Carte Interactive</router-link></li>
                        </ul>
                    </div>

                    <div class="footer-column">
                        <h4 class="footer-column-title">Plus</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'concept' }">Notre Concept</router-link></li>
                            <li><router-link :to="{ name: 'cookies' }">Utilisation des cookies</router-link></li>
                            <li><router-link :to="{ name: 'sitemap' }">Plan du site</router-link></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="footer-bottom">
                <p class="footer-copyright">
                    &copy; {{ new Date().getFullYear() }} MyEcoCar. Tous les droits reserves.
                </p>
            </div>
        </footer>
    </div>
</template>

<style>
.app-container.faq,
.app-container.faq main,
.app-container.faq #main {
    min-height: 0 !important;
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
}

.app-container.faq .view-container {
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
}

.app-container.faq .footer-component {
    display: none !important;
}
</style>

<style scoped>
.faq-page {
    background: #f6f9f7;
    min-height: 100vh;
}

.faq-hero {
    background: linear-gradient(135deg, #1f3f2e 0%, #2d5016 100%);
    color: #fff;
    padding: 80px 20px 60px;
    text-align: center;
}

.faq-hero-content {
    width: min(1400px, 96vw);
    margin: 0 auto;
}

.hero-inner {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    justify-content: center;
}

.faq-title {
    margin: 0;
    font-size: 48px;
    line-height: 1.2;
    font-weight: 700;
    color: #ffffff;
    letter-spacing: -0.5px;
}

.faq-subtitle {
    margin: 0;
    font-size: 20px;
    color: rgba(255, 255, 255, 0.88);
    line-height: 1.6;
    max-width: 800px;
}

.faq-container {
    width: min(1400px, 96vw);
    margin: 0 auto;
    padding: 54px 16px 28px;
}

.faq-list {
    display: grid;
    gap: 16px;
}

.faq-item {
    background: #fff;
    border: 1px solid #e3ebe5;
    border-radius: 10px;
    box-shadow: 0 2px 7px rgba(0, 0, 0, 0.04);
    overflow: hidden;
    transition: all 0.3s ease;
}

.faq-item:hover {
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
    border-color: #2d5016;
}

.faq-item.active {
    border-color: #2d5016;
    box-shadow: 0 6px 20px rgba(45, 80, 22, 0.15);
}

.faq-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 22px;
    background: #fff;
    border: none;
    cursor: pointer;
    transition: background 0.3s ease;
}

.faq-header:hover {
    background: #f9fbfa;
}

.faq-item.active .faq-header {
    background: #f5faf6;
    border-bottom: 2px solid #2d5016;
}

.faq-question {
    margin: 0;
    font-size: 18px;
    text-align: left;
    color: #173726;
    font-weight: 600;
    flex: 1;
}

.faq-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    margin-left: 12px;
    color: #2d5016;
    transition: transform 0.3s ease;
    flex-shrink: 0;
}

.faq-item.active .faq-icon {
    transform: rotate(180deg);
    color: #aef7b9;
}

.faq-answer {
    padding: 0 22px;
    max-height: 1000px;
    overflow: hidden;
    opacity: 1;
    transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.faq-item:not(.active) .faq-answer {
    max-height: 0;
    opacity: 0;
    padding: 0 22px;
    visibility: hidden;
}

.faq-answer p {
    margin: 0;
    padding: 16px 0 22px;
    font-size: 18px;
    line-height: 1.7;
    color: #34463c;
}

.footer-section {
    background: linear-gradient(135deg, #1f3f2e 0%, #2d5016 100%);
    color: #ffffff;
    width: 100vw;
    margin-left: calc(-50vw + 50%);
    margin-right: calc(-50vw + 50%);
    margin-top: 1.5rem;
    margin-bottom: 0 !important;
    padding: 3rem 1rem 0;
}

.footer-container {
    max-width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 0.8fr 1.2fr;
    gap: 3rem;
    align-items: start;
}

.footer-left {
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.footer-logo-section {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.footer-logo {
    width: 50px;
    height: 50px;
    object-fit: contain;
}

.footer-brand-name {
    font-family: 'Poppins', sans-serif;
    font-size: 1.5rem;
    font-weight: 700;
    color: #aef7b9;
}

.footer-social-links {
    display: flex;
    gap: 1rem;
    align-items: center;
}

.social-link {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #aef7b9;
    text-decoration: none;
    transition: all 0.3s ease;
}

.social-link:hover {
    background: rgba(174, 247, 185, 0.2);
    color: #ffffff;
    transform: translateY(-3px);
}

.social-link i {
    font-size: 1.25rem;
}

.footer-center {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2.5rem;
}

.footer-column {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.footer-column-title {
    font-family: 'Poppins', sans-serif;
    font-size: 1.1rem;
    font-weight: 600;
    color: #aef7b9;
    margin: 0;
}

.footer-links {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.footer-links li {
    margin: 0;
}

.footer-links a {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    font-family: 'Heebo', 'Poppins', sans-serif;
    font-size: 0.95rem;
    transition: color 0.3s ease;
}

.footer-links a:hover {
    color: #aef7b9;
    text-decoration: underline;
}

.footer-bottom {
    text-align: center;
    margin-top: 2rem;
    margin-bottom: 0;
    padding-top: 2rem;
    padding-bottom: 1.5rem;
    border-top: 1px solid rgba(174, 247, 185, 0.2);
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
}

.footer-copyright {
    font-family: 'Heebo', 'Poppins', sans-serif;
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.7);
    margin: 0;
}

@media (max-width: 1024px) {
    .footer-container {
        grid-template-columns: 1fr;
        gap: 2rem;
    }

    .footer-center {
        grid-template-columns: repeat(3, 1fr);
        gap: 2rem;
    }
}

@media (max-width: 768px) {
    .faq-hero {
        padding: 50px 20px 40px;
    }

    .faq-title {
        font-size: 32px;
    }

    .faq-subtitle {
        font-size: 16px;
    }

    .faq-container {
        padding: 34px 12px 28px;
    }

    .faq-header {
        padding: 16px;
    }

    .faq-question {
        font-size: 16px;
    }

    .faq-answer p {
        font-size: 16px;
        padding: 12px 0 16px;
    }

    .footer-section {
        padding: 2rem 1rem 1rem;
        margin-top: 1rem;
    }

    .footer-left {
        gap: 1.5rem;
    }

    .footer-center {
        grid-template-columns: 1fr;
        gap: 1.5rem;
    }

    .footer-column {
        gap: 0.75rem;
    }

    .footer-column-title {
        font-size: 1rem;
    }

    .footer-links a {
        font-size: 0.9rem;
    }

    .footer-logo {
        width: 40px;
        height: 40px;
    }

    .footer-brand-name {
        font-size: 1.25rem;
    }
}

@media (max-width: 480px) {
    .faq-title {
        font-size: 26px;
    }

    .faq-subtitle {
        font-size: 14px;
    }

    .faq-container {
        padding: 24px 12px;
    }

    .faq-header {
        padding: 12px;
    }

    .faq-question {
        font-size: 15px;
        font-weight: 600;
    }

    .faq-icon {
        width: 28px;
        height: 28px;
    }

    .faq-answer {
        padding: 0 12px;
    }

    .faq-answer p {
        font-size: 14px;
        padding: 12px 0 14px;
    }
}
</style>

<script>
import router from '../../router';
import bus from '../../services/bus-event.js';

export default {
    name: 'faq',
    data() {
        return {
            openItem: null,
            faqItems: [
                {
                    question: 'Qu\'est-ce que MyEcoCar ?',
                    answer: 'MyEcoCar est une plateforme de covoiturage innovante qui met en relation des conducteurs et des passagers pour partager des trajets, sans aucune commission. Notre objectif est de rendre le voyage plus economique, ecologique et convivial.'
                },
                {
                    question: 'Comment finaliser son inscription ?',
                    answer: 'Pour finaliser votre inscription, vous devez remplir votre profil avec vos informations personnelles, ajouter une photo et verifier votre adresse e-mail en cliquant sur le lien que nous vous avons envoye.'
                },
                {
                    question: 'Une assurance est-elle necessaire pour covoiturer ?',
                    answer: 'Oui, une assurance responsabilite civile est obligatoire pour le conducteur. Elle couvre les dommages qui pourraient etre causes aux passagers. Nous vous recommandons de verifier les conditions de votre contrat d\'assurance.'
                },
                {
                    question: 'Le covoiturage est-il ecologique ?',
                    answer: 'Absolument ! En partageant un vehicule, vous contribuez a reduire le nombre de voitures sur les routes, ce qui diminue les emissions de CO2, les embouteillages et la consommation de carburant. C\'est un geste simple et efficace pour la planete.'
                },
                {
                    question: 'Est-il possible de deposer une demande de covoiturage ?',
                    answer: 'Oui, si vous ne trouvez pas de trajet qui vous correspond, vous pouvez publier une demande de covoiturage via le bouton \'Publier une demande\'. Les conducteurs qui effectuent ce trajet pourront alors vous contacter directement.'
                },
                {
                    question: 'Est-il possible de changer mon pseudo ou mon mot de passe ?',
                    answer: 'Oui, vous pouvez modifier votre pseudo et votre mot de passe a tout moment depuis la section \'Profil\' de votre compte.'
                },
                {
                    question: 'Comment utiliser MyEcoCar ?',
                    answer: 'C\'est tres simple ! Utilisez la barre de recherche pour trouver un trajet, ou cliquez sur \'Proposer un trajet\' pour offrir des places dans votre voiture. Une fois le trajet trouve ou cree, vous pouvez communiquer avec l\'autre membre pour finaliser les details.'
                },
                {
                    question: 'Comment annuler une reservation ?',
                    answer: 'Pour annuler une reservation, rendez-vous dans la section \'Mes Reservations\', trouvez le trajet concerne et suivez les instructions d\'annulation. Pensez a prevenir le conducteur le plus tot possible.'
                },
                {
                    question: 'Est-il possible de supprimer mon compte utilisateur ?',
                    answer: 'Oui, vous pouvez demander la suppression de votre compte en nous contactant via le formulaire de contact. Notez que cette action est irreversible.'
                }
            ]
        };
    },
    methods: {
        toggleFaq(index) {
            this.openItem = this.openItem === index ? null : index;
        },
        onBackClick() {
            router.back();
        }
    },
    mounted() {
        bus.on('back-click', this.onBackClick);
    },
    beforeDestroy() {
        bus.off('back-click', this.onBackClick);
    }
};
</script>
